import React from 'react';

import { flagStyles } from '../settings';

const SvgIR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2544px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIR;
